$(document).ready(function () {
  if (!$("#cart-acceptance").is(":checked")) {
    $(".additional-checkout-buttons").addClass(
      "additional-checkout-buttons-hide"
    );
  }

  $("body").on(
    "click",
    '[name="checkout"], [name="goto_pp"], [name="goto_gc"]',
    function (e) {
      if (!$("#cart-acceptance").is(":checked")) {
        e.preventDefault();
        $(".cart__acceptance-error").show();
      }
    }
  );
  $("#cart-acceptance").on("click", function () {
    if ($("#cart-acceptance").is(":checked")) {
      $(".cart__acceptance-error").hide();
      $(".additional-checkout-buttons").removeClass(
        "additional-checkout-buttons-hide"
      );
    } else {
      $(".additional-checkout-buttons").addClass(
        "additional-checkout-buttons-hide"
      );
    }
  });
});
